import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { RiCheckboxCircleFill, RiInformationFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'

import {
  StyledBiddingResultModal,
  BiddingResulHeader,
  BiddingResulHeaderPrice,
  BiddingResulHeaderTitle,
  BiddingResulHeaderDesc,
  BiddingResulHeaderIcon,
  BiddingWarningArea,
} from './BiddingResult.style'

interface BiddingResultProps extends LibraryComponentType {
  onCloseAction?: () => void
  showWarningArea?: boolean
  price?: number
}

const BiddingResult: FC<BiddingResultProps> = ({ showWarningArea, onClose, onCloseAction, price }) => {
  const { t } = useTranslation()

  const sendBidAgain = () => {
    onClose?.()
  }

  useEffect(() => {
    return () => {
      onCloseAction?.()
    }
  }, [])

  return (
    <StyledBiddingResultModal>
      <BiddingResulHeader>
        <BiddingResulHeaderIcon>
          <RiCheckboxCircleFill size={48} />
        </BiddingResulHeaderIcon>
        <BiddingResulHeaderPrice>{price}€</BiddingResulHeaderPrice>
        <BiddingResulHeaderTitle>{t('bidding.resultModal.title')}</BiddingResulHeaderTitle>
        <BiddingResulHeaderDesc>{t('bidding.resultModal.desc')}</BiddingResulHeaderDesc>
      </BiddingResulHeader>
      {showWarningArea && (
        <BiddingWarningArea>
          <div>
            <RiInformationFill size={40} />
          </div>
          <b>{t('bidding.resultModal.warningAreaTitle')}</b>
          <p>{t('bidding.resultModal.warningAreaDesc')}</p>
          <Button onClick={sendBidAgain}>{t('bidding.resultModal.warningAreaButton')}</Button>
        </BiddingWarningArea>
      )}
    </StyledBiddingResultModal>
  )
}

export default BiddingResult
